import React from 'react';
import { AddressModel, UpdatedAddressMutator } from 'FormInputs/InputAddress/InputAddress';
import AppStorage from 'Storage/Storage';
import ZipCodeService from 'Requests/ZipCodeService';
import { ZipCodeErrorEnum } from 'interfaces/ZipCode';
import LocalZipCodeHouseNumberInput from './LocalZipCode';
import InternationalZipCodeHouseNumberInput from './InternationalZipCode';
import InternationalZipCodeHouseNumberInputWefox from './InternationalZipCodeWefox';
import { isBrand } from '../../../utils/utils';
import Brand from '../../../enums/Brand';

export type Props = {
  isInternationalAddress: boolean;
  addressModel: AddressModel;
  mutator: UpdatedAddressMutator;
  name: 'insured';
};

export type State = {
  queryInProgress: boolean;
  zipCodeNotFound: boolean;
};

class InputZipCodeHouseNumber extends React.PureComponent<Props> {
  private readonly storage: AppStorage;

  private readonly zipCodeService: ZipCodeService;

  private readonly isWefox: boolean;

  constructor(props: Props) {
    super(props);

    this.storage = AppStorage.getInstance();
    this.zipCodeService = new ZipCodeService();

    this.isWefox = isBrand(Brand.wefox);
  }

  private triggerZipCodeService = async (): Promise<void> => {
    const {
      addressModel,
      mutator,
    } = this.props;

    const zipCode = this.storage.getPersonalDataFormState[addressModel.zipCode];
    const number = this.storage.getPersonalDataFormState[addressModel.houseNumber];

    if (zipCode && number) {
      const result = await this.zipCodeService.checkZipCode(zipCode, number);
      if ('street' in result) {
        mutator({
          street: result.street,
          city: result.city,
        });
      } else if ('code' in result && result.code === ZipCodeErrorEnum.ZIP_CODE_VALIDATION_FAILED) {
        console.error(result.message); // eslint-disable-line no-console
      } else if ('code' in result && result.code === ZipCodeErrorEnum.ZIP_CODE_ADDRESS_NOT_FOUND) {
        throw Error(result.message);
      }
    }

    return undefined;
  };

  render(): React.ReactElement {
    const {
      addressModel,
      isInternationalAddress,
      name,
    } = this.props;

    if (isInternationalAddress && !this.isWefox) {
      return (
        <InternationalZipCodeHouseNumberInput
          addressModel={addressModel}
        />
      );
    }

    if (isInternationalAddress && this.isWefox) {
      return (
        <InternationalZipCodeHouseNumberInputWefox
          addressModel={addressModel}
        />
      );
    }

    return (
      <LocalZipCodeHouseNumberInput
        name={name}
        addressModel={addressModel}
        onBlurHandler={this.triggerZipCodeService}
      />
    );
  }
}
export default InputZipCodeHouseNumber;
